var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "M-2.7 26.7h60v6.6h-60z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M-2.7 20h60v6.7h-60z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3908",
    fillRule: "evenodd",
    d: "M-2.7 13.3h60V20h-60z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    d: "M-2.7 6.7h60v6.6h-60z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M-2.7 0h60v6.7h-60z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fffdff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.6 20A6.2 6.2 0 1 1 21 20a6.2 6.2 0 0 1 12.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3108",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m26.2 15.2-.4-.7q.2-.3.9-.3v.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.6 15v-.8s1 0 1.4.5l-.5.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3108",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27.5 15.3.5-.6.4.8-.7.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M26.4 25.9s.8-1 2.3-.7c-.2-.4-1-.3-1-.3s-.2-1.8 0-1.9h1q.1 0 0-.4c0-.2-.5-.8-.3-1l1 .1-2.4-3.2s-.3-1.2.2-1.8q.8-.9.5-1c0-.6-.9-1-1.5-.5-.3.4 0 .8 0 .8s-1 .2-1 .4h1l-.1.6s-2 1.9-.5 3.5h0s.6.6 1.2.7l.5.5v1h-1.7c-.2 0-1 0-.8 1.2l.3-.6.2.6.1-.8s0 .5.2.6c0 0 0-.8.7-.7h1s.2 1.7.1 1.9c-.4-.1-1.4 0-1.5.3h.9s-.5.4-.4.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca69c",
    fillRule: "evenodd",
    stroke: "#9ca69c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M26.7 16.8s-1.5 1.6-.9 2.8v-.2h.2v-.2h.2L26 19h.2v-.2h.2c-.4-.7 0-1.4.2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca69c",
    fillRule: "evenodd",
    stroke: "#9ca69c",
    strokeWidth: 0.1,
    d: "M27.2 15.4s0 .5-.2.7q-.2 0-.2.2t.2.1c.3 0 .7-.7.2-1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.6 15.9a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3108",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.2 16.3c-.1.1-.5.5-.1.7l.4-.3q0-.2-.3-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca69c",
    fillRule: "evenodd",
    stroke: "#9ca69c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M27 20.4v.7q.6-.3.7 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M27.7 22v.8h.4c.1 0 0-.6-.4-.8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca69c",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.7 22s-.5-1.2-1.8-1.5-1.2-1.7-1-1.8q-.1-.2.4-.1l2.4 1.1c.2 0 0 2.4 0 2.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3108",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M28.4 20.5s1.8 1 1.3 2c.5-.4.3-1 .3-1s.4 1-.6 1.6l.2.1-.2.2.6-.2-.2.2q-.1.2.5-.2l-.4.6c1-.1 3-3.3-.7-4.2l.2.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m28.5 20.2.4.3h-.4l-.6-.5-.4-.2c-.2-.1-.4-.8.3-.6l.8.4.8.2.5.6-1-.5.4.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m25.2 16.4.9-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3908",
    fillRule: "evenodd",
    d: "M-2.7 33.3h60V40h-60z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/ug.bdd9eb8a0907fe53c4ae2afc117ec396.svg";
export { ForwardRef as ReactComponent };